<template>
  <div>
    <v-row no-gutters class="overview-header">
      <v-col cols="6" sm="6">
        <div class="headline font-weight-black">Overview</div>
      </v-col>
      <v-col cols="6" sm="6">
        <div class="update text-right title" @click="update">
          <!-- <v-img
                src="@/assets/icon/refresh.png"
                lazy-src="@/assets/icon/refresh.png"
                max-width="30"
          ></v-img>-->
          <!-- <div> -->
          <v-icon left color="#FF8F03">mdi-cached</v-icon>Update
          <!-- </div> -->
          <!-- <v-btn
              class="mb-7 pl-5 pr-5 title"
              color="success"
              outlined
              rounded
              large
              @click="initialize"
            >
              <v-icon left>mdi-cached</v-icon>
              {{$vuetify.lang.t("$vuetify.courseManagement.filterBar.refresh")}}
          </v-btn>-->
        </div>
      </v-col>
    </v-row>
    <v-row no-gutters>
      <v-col cols="12" sm="3">
        <v-card
          class="pa-2 text-right"
          :class="graph === 1 ? 'step-active':''"
          outlined
          elevation="0"
          tile
          @click="changeGraph(1)"
        >
          <div class="headline font-weight-medium">{{totalLeaner.register}}</div>
          <div class="total-description subtitle-2 font-weight-black">คนลงทะเบียน</div>
        </v-card>
      </v-col>
      <v-col cols="12" sm="3">
        <v-card
          class="pa-2 text-right subCaerOverview"
          :class="graph === 2 ? 'step-active':''"
          tile
          @click="changeGraph(2)"
        >
          <div class="headline font-weight-medium">{{totalLeaner.learner}}</div>
          <div class="total-description subtitle-2 font-weight-black">คนเข้าเรียน</div>
        </v-card>
      </v-col>
      <v-col cols="12" sm="3">
        <v-card
          class="pa-2 text-right subCaerOverview"
          :class="graph === 3 ? 'step-active':''"
          elevation
          tile
          @click="changeGraph(3)"
        >
          <div class="headline font-weight-medium">{{totalLeaner.online}}</div>
          <div class="total-description subtitle-2 font-weight-black">คนออนไลน์</div>
        </v-card>
      </v-col>
      <v-col cols="12" sm="3">
        <v-card
          class="pa-2 text-right subCaerOverview"
          :class="graph === 4 ? 'step-active':''"
          elevation
          tile
          @click="changeGraph(4)"
        >
          <div class="headline font-weight-medium">{{totalLeaner.mail}}</div>
          <div class="total-description subtitle-2 font-weight-black">ข้อความเข้า</div>
        </v-card>
      </v-col>
    </v-row>
    <div class="pt-10">
      <otherGraph
        v-if="graphData && isInitOverallChartOptions"
        v-bind:data="graphData"
        v-bind:overallChartOptions="overallChartOptions"
      ></otherGraph>
      <div v-else style="min-height: 335px;">
        <v-progress-circular
          style="display: block; margin-left: auto; margin-right: auto; margin-top: 40px;"
          indeterminate
          color="primary"
        ></v-progress-circular>
      </div>
    </div>
    <!-- <v-tabs
    fixed-tabs
  >
    <v-tab>
      <div
            class="pa-3 text-right"
            outlined
            tile
          >
            <div>20,489
              </div>
              <div>คนลงทะเบียน
                </div>
          </div>
    </v-tab>
    <v-tab>
      Another Selection
    </v-tab>
    <v-tab>
      Items
    </v-tab>
    <v-tab>
      Another Screen
    </v-tab>
    </v-tabs>-->
  </div>
</template>
<script>
import {
  getJoinedLearner,
  getRegisteredLearner,
  getOnlineLearner,
  getMessageLearner,
  getTotalLearner
} from "@/service/course/live";
import moment from "moment";
import otherGraph from "./dashboardGraph/otherGraph";
export default {
  name: "dashboard",
  components: {
    otherGraph
  },
  props: {
    liveId: {
      type: String
    }
  },
  data: () => ({
    gab: 60,
    totalLeaner: {
      register: 0,
      learner: 0,
      online: 0,
      mail: 0
    },
    graph: 1,
    joinedLearner: null,
    registeredLearner: null,
    onlineLearner: null,
    graphData: null,
    messageLearner: null,

    // graph
    overallChartOptions: {
      chart: {
        type: "line",
        stacked: false,
        height: 350,
        zoom: {
          type: "x",
          enabled: true,
          autoScaleYaxis: true
        },
        toolbar: {
          autoSelected: "zoom"
        }
      },
      dataLabels: {
        enabled: false
      },
      markers: {
        size: 1
      },
      title: {
        text: "",
        align: "left"
      },
      grid: {
        xaxis: {
          lines: {
            show: true
          }
        },
        yaxis: {
          lines: {
            show: true
          }
        }
      },
      fill: {
        // type: "gradient",
        // gradient: {
        //   shadeIntensity: 1,
        //   inverseColors: false,
        //   opacityFrom: 0.5,
        //   opacityTo: 0.5,
        //   stops: [0, 90, 100]
        // }
      },
      yaxis: {
        labels: {
          formatter: function(val) {
            return Math.floor(val);
          }
        },
        title: {
          text: "Number of Students"
        }
      },
      xaxis: {
        // type: "datetime"
        // title: {
        //   text: "Date"
        // }
        //  tickAmount: 5000,
        categories: []
      },
      tooltip: {
        x: {
          format: "dd/MM/yy"
        }
      }
    },
    overallSeries: [
      {
        name: "Num of Students",
        data: []
      }
    ],
    randomRegistered: [0, 45, 60, 75, 80],
    randomJoined: [0, 40, 55, 70, 80],
    randomStudent: [0, 10, 35, 40, 80],
    randomMessage: [0, 7, 30, 50, 40],
    isInitOverallChartOptions: false
  }),
  async mounted() {
    await this.reloadInfo();
    await this.changeGraph(1);
  },
  computed: {},
  methods: {
    mockDateTime() {
      const mock = [];
      function randomDate(start, end) {
        return new Date(
          start.getTime() + Math.random() * (end.getTime() - start.getTime())
        );
      }
      for (let i = 0; i < 100; i++) {
        const ranD = randomDate(new Date(2020, 0, 1), new Date());
        mock.push({
          date: ranD.getTime()
        });
      }
      return mock;
    },
    putInRange(target) {
      const resultObject = [];
      const timeRange = this.createTimeRange();
      timeRange.forEach(() => resultObject.push(0));
      target.forEach(t => {
        const compareInt = parseInt(moment(t.created_at).format("Hmm"));
        timeRange.forEach(t => {
          if (compareInt > t.range[0] && compareInt < t.range[1]) {
            resultObject[t.index] = resultObject[t.index]
              ? resultObject[t.index] + 1
              : 1;
          }
        });
      });
      return resultObject;
    },
    createTimeRange() {
      const result = this.createTimeLiner()[0];
      const resultWithRange = [];
      for (let i = 0; i < result.length - 1; i += 1) {
        resultWithRange.push({
          range: [result[i], result[i + 1]],
          index: i
        });
      }
      return resultWithRange;
    },
    createTimeRangeDisplay() {
      return this.createTimeLiner()[1];
    },
    createTimeLiner() {
      const result = [];
      const display = [];
      for (let d = 0; d < 24; d += 1) {
        for (let m = 0; m < 60; m += this.gab) {
          let lm = "";
          result.push(d * 100 + m);
          if (m < 10) {
            lm = "0";
          }
          display.push(`${d}:${lm}${m}`);
        }
      }
      return [result, display];
    },
    initOverallChartOptions() {
      if (this.graph !== 3) {
        this.isInitOverallChartOptions = false;
        this.overallChartOptions.xaxis.categories = this.createTimeRangeDisplay();
      }
    },
    async changeGraph(graphNumber) {
      this.graph = graphNumber;
      this.initOverallChartOptions();
      if (graphNumber === 1) {
        await this.getGraphRegisteredLearner();
      } else if (graphNumber === 2) {
        await this.getGraphJoinedLearner();
      } else if (graphNumber === 3) {
        await this.getGraphOnlineLearner();
      } else if (graphNumber === 4) {
        await this.getGraphMessageLearner();
      }
      this.isInitOverallChartOptions = true;
      // this.graphData = this.putInRange(this.mockDateTime());
    },
    async update() {
      await this.reloadInfo();
      await this.changeGraph(this.graph);
    },
    async reloadInfo() {
      let result = await getTotalLearner({ idlivestream: this.liveId });
      this.totalLeaner = result;

      // this.getGraphJoinedLearner()
      // this.getGraphRegisteredLearner()

      // this.getGraphOnlineLearner()
      // this.getGraphMessageLearner()
    },
    async getGraphRegisteredLearner() {
      this.graphData = this.putInRange(
        await getRegisteredLearner({
          idlivestream: this.liveId
        })
      );
    },
    async getGraphJoinedLearner() {
      this.graphData = this.putInRange(
        await getJoinedLearner({
          idlivestream: this.liveId
        })
      );
    },
    async getGraphMessageLearner() {
      this.graphData = this.putInRange(
        await getMessageLearner({
          idlivestream: this.liveId
        })
      );
    },
    async getGraphOnlineLearner() {
      this.graphData = null;
      const graphData = (
        await getOnlineLearner({
          idlivestream: this.liveId
        })
      ).map(o => o.countOnline);
      const arr = [];
      for (let i = 1; i <= graphData.length; i += 1) {
        arr.push(i.toString());
      }
      this.overallChartOptions.xaxis.categories = arr;
      this.graphData = graphData;
    },
    async generateGraph(data) {
      console.log(data);
    }
  }
};
</script>
<style scoped>
.v-application--is-ltr
  .v-tabs--centered
  > .v-tabs-bar
  .v-tabs-bar__content
  > :last-child,
.v-application--is-ltr
  .v-tabs--fixed-tabs
  > .v-tabs-bar
  .v-tabs-bar__content
  > :last-child {
  margin-right: auto;
}
.total-description {
  font-size: 16px;
  color: #308ab7;
}
.step-active {
  background-color: #308ab7;
  color: white;
  border: thin solid #308ab7 !important;
}
.step-active > .total-description {
  color: white;
}
.overview {
  font-size: 20px;
  font-weight: 500;
}

.update {
  color: #ff8f03;
  cursor: pointer;
}
.overview-header {
  padding-bottom: 32px !important;
}
.subCaerOverview {
  border: thin solid #eaeaea !important;
  border-left-width: 0px !important;
  box-shadow: unset !important;
}
</style>